import React, { useRef } from 'react';
import SwiperCore, { Lazy, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import { Size, useWindowSize } from '../../hook/useWindowSize';
import { Article } from '../../types/Article';
import ArticleCard, { ArticleCardType } from '../article-card/article-card';
import Icon, { IconType } from '../icons';
import styles from './related-articles.module.scss';

SwiperCore.use([Lazy, Navigation]);
export interface RelatedArticlesProps {
    title: string;
    description?: string;
    viewAllSeriesText: string;
    viewAllSeriesUrl: string;
    articles: Article[];
}
interface Props {
    relatedArticles: RelatedArticlesProps;
}

const RelatedArticles: React.FC<Props> = (props: Props) => {
    const { title, description, viewAllSeriesText, viewAllSeriesUrl, articles } = props.relatedArticles;
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const windowSize: Size = useWindowSize();
    const navigationConfig = { prevEl: prevRef.current ? prevRef.current : undefined, nextEl: nextRef.current ? nextRef.current : undefined };

    const isMobileOrTablet = (): boolean => {
        const windowWidth: number = windowSize.width || 0;
        if (windowWidth < 1440) {
            return true;
        } else {
            return false;
        }
    };

    return (
        <div className={styles.relatedArticlesContainer}>
            <div className={styles.relatedArticlesHeader}>
                <div className={styles.relatedArticlesHeaderInfo}>
                    <div className={styles.relatedArticlesHeaderTitle}>{title}</div>
                    <div className={styles.relatedArticlesHeaderDescription}>{description}</div>
                </div>
                <a href={viewAllSeriesUrl} target="_self" className={styles.relatedArticlesViewAll}>
                    <span>{viewAllSeriesText}</span>
                    <Icon type={IconType.ArrowRightMedium} />
                </a>
            </div>
            <div className={styles.relatedArticleSlider}>
                <div ref={nextRef} className={styles.swiperButtonNext}>
                    <Icon type={IconType.ArrowRightMedium} />
                </div>
                <div ref={prevRef} className={styles.swiperButtonPrev}>
                    <Icon type={IconType.ArrowRightMedium} />
                </div>
                <Swiper
                    key={title}
                    navigation={navigationConfig}
                    onInit={(swiper) => {
                        if (!swiper) {
                            return;
                        }
                        const navigation = swiper?.params.navigation as any;
                        navigation.prevEl = prevRef.current;
                        navigation.nextEl = nextRef.current;
                        swiper.navigation.update();
                    }}
                    slidesPerView={'auto'}
                    spaceBetween={isMobileOrTablet() ? 8 : 24}
                    centeredSlides={true}
                    centeredSlidesBounds={true}
                    watchOverflow={true}
                    lazy={{ loadPrevNext: true, loadPrevNextAmount: 1 }}
                    updateOnWindowResize={true}
                    className={styles.relatedArticleSliderSeoSeriesSlider}
                >
                    {(articles || []).map((article: Article) => {
                        return (
                            <SwiperSlide className={styles.relatedArticleSlide} key={article.articleUrl}>
                                <ArticleCard type={ArticleCardType.Small} article={article} />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </div>
    );
};

export default RelatedArticles;
